import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default ArrowBackIcon;
